/**
 * Given a field, return the string representation of the accessor : its key
 * @param {Object} field Field object
 * @returns {{keyInObject: String, keyInDataToSend: String}} Key of the value in the object
 */
const getFieldKey = field => {
    const fieldName = [...(field.parentKeys || []), field.key].join('.');
    if (field.type === 'combobox') {
        return {
            keyInObject: `${fieldName}.value`,
            keyInDataToSend: fieldName
        };
    } else {
        return {
            keyInObject: fieldName,
            keyInDataToSend: fieldName
        };
    }
};

/**
 * Given an object and a nested key, return the value pointed
 * @param {Object} object Object to explore
 * @param {String} key Nested key (eg. toto.bar)
 * @returns {Object} The value pointer by the key
 */
const resolveNestedKey = (object, key) => {
    let pointerObject = object;
    const splittedKeys = key.split('.');
    splittedKeys.forEach(keyPart => {
        if (pointerObject) {
            pointerObject = pointerObject[keyPart];
        }
    });
    return pointerObject;
};

/**
 * Given an object and a key, return the value
 * @param {Object} data Object data
 * @param {String} key String of the field in the object
 * @returns {Object} Value of the field in the object
 */
const getFieldValue = (data, key) => {
    if (key.indexOf('.') >= 0) {
        return resolveNestedKey(data, key);
    } else {
        return data[key];
    }
};

/**
 * From an object, extract the specified fields
 * @param {Object} data JSON object
 * @param {{key: String}[]} fields Array of fields
 * @returns {Object} Object data to send to the API
 */
const extractDataToSendFromObject = (data, fields) => fields.reduce(
    // For each field
    (dataToSend, field) => {
        const fieldKeys = getFieldKey(field);

        // Resolve the key
        let acc = dataToSend;
        fieldKeys.keyInDataToSend.split('.').forEach(
            (keyPart, indexKeyPart, arrayKeyPart) => {
                acc[keyPart] = acc[keyPart] || {};
                if (indexKeyPart === arrayKeyPart.length - 1) {
                    acc[keyPart] = getFieldValue(data, fieldKeys.keyInObject);
                }
                acc = acc[keyPart];
            }
        );

        return dataToSend;
    },
    {}
);

export { extractDataToSendFromObject, resolveNestedKey, getFieldValue, getFieldKey };
